import { actionsFactory, createAction } from '@ngneat/effects';

const actions = actionsFactory('cart');
export const addedVoucher = actions.create('Added Voucher');
export const errorAddingVoucher = actions.create('Error Voucher');
